import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

// Keep the original route, graph API, cards and configuration schema.
export const catalogCodeGraphPlugin = catalogGraphPlugin.withOverrides({
  extensions: [
    catalogGraphPlugin.getExtension('page:catalog-graph').override({
      factory(originalFactory, { config }) {
        return originalFactory({
          params: {
            loader: () =>
              import('./CatalogCodeGraphPage').then(module => (
                <module.CatalogCodeGraphPage
                  {...config}
                  initialState={config}
                />
              )),
          },
        });
      },
    }),
  ],
});
